const panels = document.querySelectorAll('.side-panel__categ_1>.side-panel__categ-toggle');
const panels_niv2 = document.querySelectorAll('.side-panel__categ_2>.side-panel__categ-toggle');
const $toggle_button = document.querySelector('.side-panel__toggle-results');

function notifyCategoryInteraction() {
    document.dispatchEvent(new CustomEvent('actMap:categoryInteraction'));
}

$toggle_button.addEventListener('click', function() {
    $toggle_button.classList.toggle('side-panel__toggle-results--active');
    document.querySelector('.side-panel').classList.toggle('side-panel--fully-opened');
});

Array.prototype.forEach.call(panels,function(el){
    // Premier Niveau
    el.addEventListener('click',function(){
        //console.log('niv1');
        Array.prototype.forEach.call(panels_niv2,function(p){
            p.parentElement.classList.remove('side-panel__categ--is-open')
            el.setAttribute('aria-expanded','false');
        });
        if(el.parentElement.classList.contains('side-panel__categ--is-open')){
            el.parentElement.classList.remove('side-panel__categ--is-open')
            el.setAttribute('aria-expanded','false');
        }else{
            Array.prototype.forEach.call(panels,function(p){
                p.parentElement.classList.remove('side-panel__categ--is-open')
                el.setAttribute('aria-expanded','false');
            });
            el.parentElement.classList.add('side-panel__categ--is-open')
            el.setAttribute('aria-expanded','true');
        }
        //el.parentElement.classList.toggle('side-panel__categ--is-open')
        schedule_act_sync_categories_to_list();
        notifyCategoryInteraction();
    });
})

Array.prototype.forEach.call(panels_niv2,function(el){
    // Premier Niveau
    el.addEventListener('click',function(){
        //console.log('niv2');
        if(el.parentElement.classList.contains('side-panel__categ--is-open')){
            el.parentElement.classList.remove('side-panel__categ--is-open');
            el.setAttribute('aria-expanded','false');
        }else{
            Array.prototype.forEach.call(panels_niv2,function(p){
                p.parentElement.classList.remove('side-panel__categ--is-open')
                el.setAttribute('aria-expanded','false');
            });
            el.parentElement.classList.add('side-panel__categ--is-open')
            el.setAttribute('aria-expanded','true');
        }
        //el.parentElement.classList.toggle('side-panel__categ--is-open')
        schedule_act_sync_categories_to_list();
        notifyCategoryInteraction();
    });
})

/** Run sync after layout settles (replaces double setTimeout 30/60 ms). */
function schedule_act_sync_categories_to_list() {
    requestAnimationFrame(function () {
        requestAnimationFrame(act_sync_categories_to_list);
    });
}

function normalizeMultiSelectSnapshot(val) {
    if (val == null || val === '') {
        return [];
    }
    var arr = Array.isArray(val) ? val.slice() : [String(val)];
    return arr.map(String).sort();
}

function multiSelectValuesEqual(next, prev) {
    var a = normalizeMultiSelectSnapshot(next);
    var b = normalizeMultiSelectSnapshot(prev);
    if (a.length !== b.length) {
        return false;
    }
    for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
}

function act_sync_categories_to_list(){
    const selects = document.getElementsByClassName('map-category-select');
    Array.prototype.forEach.call(selects, function (el) {
        var ogValue;
        if (Array.isArray(el.value)) {
            ogValue = el.value.slice();
        } else if (el.value != null && el.value !== '') {
            ogValue = [String(el.value)];
        } else {
            ogValue = [];
        }
        Array.prototype.forEach.call(el.options, function (option) {
            var curEl = document.querySelector('[data-categ="' + option.value + '"]');
            if (!curEl) {
                return;
            }
            var open = curEl.parentElement.classList.contains('side-panel__categ--is-open');
            var v = String(option.value);
            var idx = -1;
            for (var i = 0; i < ogValue.length; i++) {
                if (String(ogValue[i]) === v) {
                    idx = i;
                    break;
                }
            }
            var includes = idx !== -1;
            if (includes && !open) {
                ogValue.splice(idx, 1);
            }
            if (!includes && open) {
                ogValue.push(option.value);
            }
        });
        if (!multiSelectValuesEqual(ogValue, el.value)) {
            el.setValue(ogValue);
        }
    });
}